import * as Yup from 'yup';

const requiredString = Yup.string().required('Campo Obrigatório');

const fieldsIdentification = {
  name: requiredString,
  street: requiredString,
  cep: requiredString,
  number: requiredString,
  uf: requiredString,
  city: requiredString,
  cpfCnpj: requiredString,
  observation: Yup.string(), // opcional
  nature: requiredString.nullable(),
  district: requiredString,
};

const fieldsContacts = {
  contacts: Yup.array().of(
    Yup.object({
      representative: requiredString,
      position: requiredString,
      phone_number: requiredString,
      contact_number: requiredString,
      email: requiredString,
    })
  ),
};

const fieldsBankData = {
  bank_information: Yup.object({
    bank_name: requiredString.nullable(),
    account_type: requiredString,
    agency: requiredString,
    account_number: requiredString,
    account_digit: requiredString,
    operation: requiredString,
    ownership_nature: requiredString,
    ownership_document: requiredString,
    ownership: requiredString,
    observation: Yup.string(), // opcional
  }),
};

export const schemaProvider = (includeBankData = false) =>
  Yup.object({
    ...fieldsIdentification,
    ...fieldsContacts,
    ...(includeBankData ? fieldsBankData : {}),
  });
